module.exports = __webpack_public_path__ + "static/conduccion---panel-de-control-2dd1bc5c6c216f26c8bdaa0e2b3cbbe6.jpg";